import React, { Component } from 'react';
import { withScope, captureException } from '@golden/sentry-base';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, eventId: null };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        withScope((scope) => {
            scope.setExtras({ componentStack: info.componentStack });
            const eventId = captureException(error);
            this.setState({ eventId, hasError: true });
        });
        console.error(error);
        console.log(info);
    }
    render() {
        const { errorPage: ErrorPage } = this.props;
        if (this.state.hasError)
            return (React.createElement(ErrorPage, null));
        return this.props.children;
    }
}
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map